import React from "react";
import Footer from "../Footer/Footer";
import Navbar from "../Navbar/Navbar";
import { useParams } from "react-router-dom";
import { data } from "./config";
function TypeMed() {
  let param = useParams()
  console.log(param);
  let fixId = Number(param.id)

  React.useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  const item = data[fixId]
  return (
    <div>
      <Navbar />
      <div className="custom__page">
        <div className="container">
          <div className="header__custom">
            <h4>{item.kofedra}</h4>
            <div className="card__custom">
              <div className="box__custom">
                <img src={item.img} alt />
              </div>
              <div className="box-1__custom">
                <p>{item.name} </p>
                <span>{item.job}</span>
                <br />
                <br />
                <hr />
                <div className="wer__custom">
                  <div className="malinki__custom">
                    <p>E-pochta</p>
                    <span>{item.email}</span>
                  </div>
                  <div className="malinki1__custom">
                    <p>Telefon raqami:</p>
                    <span>{item.number}</span>
                  </div>
                 
                </div>
                <div className="wer__custom">
                  <div className="malinki__custom">
                    <p>Lavozimi</p>
                    <span>Kafedra mudiri</span>
                  </div>
                
                </div>
              </div>
            </div>
          </div>

          <div className="card1__custom">
            <div className="header__custom">
              <h4 style={{ marginBottom: "1vw" }}>Kafedra maqsadi:</h4>
            </div>
            <p>
             {item.maqsad}
            </p>

            <div className="header__custom">
              <h4 style={{ marginBottom: "1vw" }}>Kafedra vazifalari:</h4>
            </div>
            <p>
             {item.vazifa}
            </p>

          </div>

          <div className="card5__custom">
            <img src="/img/5.png" alt />
            <img src="/img/5.png" alt />
            <img src="/img/5.png" alt />
          </div>
        </div>
      </div>
    <div className="mt"></div>
      <Footer />
    </div>
  );
}

export default TypeMed;
